<template>
  <div class="form-task-validations block full">
    <h4>Formulario crear / editar tareas</h4>    
    <div class="feedback-task-validations row" v-if="message != ''">
      <div class="col-sm-12">
        <div class="alert alert-success" role="alert">
          {{message}}
        </div>        
      </div>
    </div>
    <div class="row row-item-form-task-validation">
      <div class="col-sm-4">
        <label for="">Evento al que pertenece</label>
      </div>
      <div class="col-sm-8">
        <select class="form-control select-assignment-types" v-model="taskValidation.event_type" v-if="assignmentTypes != null">
          <option v-for="typeEvent in typeEvents" :key="typeEvent.id" :value="typeEvent.id"> {{ typeEvent.name }} </option>
        </select>
      </div>
    </div>
    <div class="row row-item-form-task-validation">
      <div class="col-sm-4">
        <label for="">Tipo de asignación</label>
      </div>
      <div class="col-sm-8">
        <select class="form-control select-assignment-types" v-model="taskValidation.assignment_type_id" v-if="assignmentTypes != null">
          <option v-for="assignmentType in assignmentTypes" :key="assignmentType.id" :value="assignmentType.id"> {{ assignmentType.name | assignmentTypeName}} </option>
        </select>
      </div>
    </div>
    <div class="row row-item-form-task-validation">
      <div class="col-sm-4">
        <label for="">Tarea</label>
      </div>
      <div class="col-sm-8">
        <input class="form-control" type="text" v-model="taskValidation.name">
      </div>
    </div>
    <div class="row">
      <div class="col-sm-2">
        <button class="form-control btn btn-primary" @click.prevent="save">Guardar</button>
      </div>
      <div class="col-sm-2">
        <button class="form-control btn btn-danger" @click.prevent="restoreTaskValidation">Limpiar</button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import { mapGetters, mapMutations } from 'vuex'
  export default {
    data() {
      return {
        message: ''
      }
    },
    computed: {
      ...mapGetters(['taskValidations', 'assignmentTypes', 'taskValidation', 'typeEvents'])
    },
    methods: {
      ...mapMutations(['changeTaskValidations', 'changeAssignmentTypes', 'changeTaskValidation']),
      setCredentials (){
        axios.defaults.headers['x-csrf-token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        axios.defaults.headers.common['Accept'] = 'application/json';
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      },
      save () {
        this.setCredentials()
        if (this.taskValidation.id == null) {
          this.create()
        } else {
          this.update()
        }
      },
      async create () {
        const request = await axios.post('/task_validations', { task_validation: this.taskValidation }, {})
        this.processRequest(request, 'create')
      },
      async update () {
        const request = await axios.put(`/task_validations/${this.taskValidation.id}`, { task_validation: this.taskValidation }, {})
        this.processRequest(request, 'update')
      },
      processRequest (request, origin) {
        if (request.status == 200 || request.status == 201) {
          if (origin == 'create') {
            this.message = 'Registro guardado'
          } else {
            this.message = 'Registro actualizado'
          }          
          this.changeTaskValidations(request.data.task_validations)
          this.restoreTaskValidation()
          setTimeout(() => this.message = '', 3000);
        }
      },
      restoreTaskValidation () {
        const taskValidation = {
          id: null,
          assignment_type_id: null,
          event_type: null,          
          name: null
        }
        this.changeTaskValidation(taskValidation)
      }
    },
    filters: {
      assignmentTypeName: function(value) {
        switch (value) {
          case 'academic':
            return 'Académica'
         case 'antecedents':
            return 'Antecedentes'            
          case 'laboral':
            return 'Laboral'
          case 'visit':
            return 'Visita'
          case 'datacredito':
            return 'Datacrédito'
          case 'personal':
            return 'Personal'
          case 'remote_work_visit':
            return 'Visita para teletrabajo'                                                
          default:
            return value
        }
      }
    }
  }
</script>

<style scoped>

</style>